const KEY = "gv_cookie_consent";
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const PM_AGID = process.env.REACT_APP_PARAMOUNT_AGID;
const PM_ADID = process.env.REACT_APP_PARAMOUNT_ADID;
const PM_EVENTS = { PageView: "site_visit", Lead: "lead", CompleteRegistration: "lead", Subscribe: "lead", Purchase: "purchase" };
const GTAG_ID = process.env.REACT_APP_GOOGLE_TAG_ID;
const GTAG_EVENTS = { PageView: "page_view", Lead: "generate_lead", CompleteRegistration: "sign_up", Subscribe: "generate_lead", Purchase: "purchase" };
let loaded = false;
let pmQueue = null;

export const getConsent = () => localStorage.getItem(KEY);

function loadParamount() {
  if (!PM_AGID || pmQueue) return;
  pmQueue = [];
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://qscripts.s3.amazonaws.com/pscript.js";
  s.onload = () => { pmQueue.forEach((a) => window.qbit?.(...a)); pmQueue = []; };
  document.head.appendChild(s);
}

function paramount(event, params) {
  const name = PM_EVENTS[event];
  if (!name || !PM_AGID) return;
  const args = ["event", name, { agid: PM_AGID, adid: PM_ADID, referrer: document.referrer, site_url: window.location.href, timestamp: Date.now(), ...(params || {}) }];
  if (window.qbit) window.qbit(...args); else pmQueue.push(args);
}

function loadGoogle() {
  if (!GTAG_ID) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); }; // eslint-disable-line prefer-rest-params
  window.gtag("js", new Date());
  window.gtag("config", GTAG_ID, { send_page_view: false });
}

function google(event, params) {
  const name = GTAG_EVENTS[event];
  if (!name || !window.gtag) return;
  window.gtag("event", name, name === "page_view" ? { page_location: window.location.href, page_path: window.location.pathname } : params);
}

const LI_PARTNER = process.env.REACT_APP_LINKEDIN_PARTNER_ID;
const LI_SIGNUP = process.env.REACT_APP_LINKEDIN_SIGNUP_CONVERSION_ID;

function loadLinkedIn() {
  if (!LI_PARTNER) return;
  window._linkedin_partner_id = LI_PARTNER;
  window._linkedin_data_partner_ids = [LI_PARTNER];
  window.lintrk = window.lintrk || Object.assign((a, b) => window.lintrk.q.push([a, b]), { q: [] });
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
  document.head.appendChild(s);
}

function loadPixel() {
  if (loaded) return;
  loaded = true;
  loadParamount();
  loadGoogle();
  loadLinkedIn();
  if (!PIXEL_ID) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,"script","https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
}

export function setConsent(value) {
  localStorage.setItem(KEY, value);
  if (value === "accepted") { loadPixel(); track("PageView"); }
  else if (loaded) window.location.reload();
}

export function track(event, params) {
  if (getConsent() !== "accepted") return;
  loadPixel();
  if (window.fbq) window.fbq("track", event, params);
  paramount(event, params);
  google(event, params);
}

export function trackSignup() {
  track("CompleteRegistration");
  if (getConsent() !== "accepted") return;
  if (window.fbq) window.fbq("track", "Lead");
  if (LI_SIGNUP && window.lintrk) window.lintrk("track", { conversion_id: Number(LI_SIGNUP) });
}
